export default function FaqPage() {
  const categories = document.querySelectorAll('[data-categoryslug]');

  if (!categories) return null;

  categories.forEach((el) => {
    el.addEventListener('click', () => {
      const slug = el.dataset.categoryslug;
      let newLocation = '';
      if (slug) {
        newLocation = `/faq/${slug}`;
      } else {
        newLocation = '/faq';
      }

      if (window.location.pathname !== newLocation) {
        window.location = newLocation;
      }
    });
  });
}
